import { useState } from "react";
import Quiz from "./components/Quiz";
import Result from "./components/Result";

function App() {
 const [submitted, setSubmitted] = useState(false);
 const [result, setResult] = useState({ answers: [], totalScore: 0 });

 return (
  <div>
   <Quiz
    onFinish={(res: any) => {
     setResult(res);
     setSubmitted(true);
    }}
   />
  </div>
 );
}

export default App;
